import { FC, useCallback, useRef } from 'react';

import { SearchInput, useDebounce } from '@hh.ru/magritte-ui';

import { useRequestCancel } from 'hooks/common/useRequestCancel';
import useTrls from 'hooks/translation/useTrls';

import { fetchWizardVacancySearch } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyFiltersPanel/fetchWizardVacancySearch';

import {
    selectWizardVacancySearchValue,
    setWizardVacanciesIsLoading,
    setWizardVacancySearchValue,
} from 'store/models/campaignCreationWizard';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    placeholder: 'CampaignCreationWizard.VacancySelectStep.search.placeholder',
};

export const VacancySearchField: FC = () => {
    const dispatch = useDispatch();
    const trl = useTrls();
    const searchValue = useSelector(selectWizardVacancySearchValue);
    const { abortRequest, abortSignal } = useRequestCancel();

    const abortRequestRef = useRef(abortRequest);
    const abortSignalRef = useRef(abortSignal);
    abortRequestRef.current = abortRequest;
    abortSignalRef.current = abortSignal;

    const debouncedSearch = useDebounce(
        useCallback(
            (newValue: string) => {
                abortRequestRef.current();
                void dispatch(
                    fetchWizardVacancySearch({ nameFilter: newValue, abortSignal: abortSignalRef.current() })
                );
            },
            [dispatch]
        ),
        500
    );

    const handleChange = (newValue: string) => {
        dispatch(setWizardVacancySearchValue(newValue));
        dispatch(setWizardVacanciesIsLoading(true));
        debouncedSearch(newValue);
    };

    return (
        <SearchInput
            value={searchValue}
            onChange={handleChange}
            placeholder={trl(TrlKeys.placeholder)}
            clearable
            data-qa="wizard-vacancy-search"
        />
    );
};
